import React from 'react';

import { CoastTemplate } from 'src/templates';

const SecretTransfer = () => {
  return (
    <CoastTemplate title='Transfer'>
      <iframe
        style={{ width: '100%', height: '100%' }}
        title='transfer demo'
        src='https://plaid.coastdemo.com/share/66a2873191aa545b32f62095?mode=link'
      />
    </CoastTemplate>
  );
};

SecretTransfer.displayName = 'Prototype';

export default SecretTransfer;
